module.exports = __webpack_public_path__ + "static/img/Rising-Sun.a386be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rising-Sun.jpg
// module id = AJhm
// module chunks = 0